// import i18n from '@/i18n/index'

export default {
  basicInformation: [{
    prop: 'name'
  }, {
    prop: 'hotel'
  }, {
    prop: 'hotel_room'
  }, {
    prop: 'price'
  }, {
    prop: 'description'
  }, {
    prop: 'updated_at'
  }, {
    prop: 'created_at'
  }]
}
